module.exports = "/_next/static/images/banner_ebook_en-39d3938801dbc19b42be094605e6183e.jpg";